import { Link } from "react-router-dom";
import SideBareMagasin from "../SideBareMagasin/SideBareMagasin";
import "./ajouterCommercial.css";
import { useContext, useEffect, useState } from "react";
import { MagasinContext } from "../../../Context/MagasinContext";
import { CommercialInfo } from "../../../Modeles/Commercial";
import SideBarMagasinMobile from "../SideBareMagasin/SidebarMagasinMobile";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";

const AjouterCommecial: React.FC<CommercialInfo> = ({
  setNom,
  setPrénom,
  setTélephone,
  setVille,
  setRemiseGlobale,
  Prenom,
  handleSubmit,
  MessageError,
  showSuccessPopup,
  setShowSuccessPopup,
  showErrorPopup,
  setCredit,
  setEmail,
  setPassword,
  Cin,
  setCin,
}) => {
  const magasinContext = useContext(MagasinContext);
  const MagasinId = localStorage.getItem("MagasinId");
  const id = MagasinId || magasinContext.id?.id;

  const handleGoBack = () => window.history.back();

  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ─── MOBILE VIEW ─────────────────────────────── */
  if (screenWidth <= 450) {
    return (
      <>
              <NewSideBarMagasins />
        
        <div className="page-wrapper-ajcmu">

          {/* Back */}
          <div className="bar-retour-ajcmu">
            <Link to="" onClick={handleGoBack} className="icon-retour-ajcmu">
              <i className="bi bi-arrow-left-short" />
            </Link>
          </div>

          {/* Title */}
          <div className="marque-ajcmu">
            <h4>Ajouter un commercial</h4>
          </div>

          {/* Form */}
          <div className="form-card-ajcmu">
            <form onSubmit={handleSubmit} method="post">
              {MessageError !== "" && (
                <div className="alert-danger-ajcmu">
                  <i className="bi bi-exclamation-circle" /> {MessageError}
                </div>
              )}

              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Nom</label>
                <input
                  type="text"
                  className="form-control-ajcmu"
                  onChange={(e) => setNom(e.target.value)}
                />
              </div>
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Prénom</label>
                <input
                  type="text"
                  className="form-control-ajcmu"
                  onChange={(e) => setPrénom(e.target.value)}
                />
              </div>
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Numéro de téléphone</label>
                <input
                  type="number"
                  className="form-control-ajcmu"
                  onChange={(e) => setTélephone(e.target.value)}
                />
              </div>
              <div className="form-row-ajcmu">
                <div className="form-group-ajcmu">
                  <label className="form-label-ajcmu">Ville</label>
                  <input
                    type="text"
                    className="form-control-ajcmu"
                    onChange={(e) => setVille(e.target.value)}
                  />
                </div>
                <div className="form-group-ajcmu">
                  <label className="form-label-ajcmu">Remise (%)</label>
                  <input
                    type="number"
                    className="form-control-ajcmu"
                    onChange={(e) => setRemiseGlobale(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Solde (MAD)</label>
                <input
                  type="number"
                  className="form-control-ajcmu"
                  onChange={(e) => setCredit && setCredit(e.target.value)}
                  placeholder="0"
                />
              </div>

              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">CIN</label>
                <input
                  type="text"
                  className="form-control-ajcmu"
                  onChange={(e) => setCin && setCin(e.target.value)}
                  placeholder="EX123456"
                  maxLength={8}
                />
              </div>

              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Email</label>
                <input
                  type="email"
                  className="form-control-ajcmu"
                  onChange={(e) => setEmail && setEmail(e.target.value)}
                  placeholder="email@exemple.com"
                />
              </div>
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Mot de passe</label>
                <input
                  type="password"
                  className="form-control-ajcmu"
                  onChange={(e) => setPassword && setPassword(e.target.value)}
                  placeholder="••••••••"
                />
              </div>

              <div className="btn-submit-wrap-ajcmu">
                <button className="btn-submit-mobile-ajcmu" type="submit">
                  Ajouter un commercial
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Popup */}
        {showSuccessPopup && (
          <div className="popup-overlay-ajcmu">
            <div className="popup-box-ajcmu">
              <i className="bi bi-check-circle-fill popup-icon-ajcmu" />
              <h5>Félicitations ! Commercial ajouté</h5>
              <p>Identifiants envoyés sous 24h par email</p>
            </div>
          </div>
        )}
        {showErrorPopup && (
          <div className="popup-overlay-ajcmu">
            <div className="popup-box-ajcmu" style={{ color: 'red' }}>
              <i className="bi bi-exclamation-circle-fill popup-icon-ajcmu" style={{ color: 'red' }} />
              <h5 style={{ color: 'red' }}>Erreur !</h5>
              <p>{MessageError}</p>
            </div>
          </div>
        )}
      </>
    );
  }

  /* ─── DESKTOP VIEW ────────────────────────────── */
  return (
    <>
      <NewSideBarMagasins />
      <div className="page-wrapper-ajcmu">

        {/* Back */}
        <div className="bar-retour-ajcmu">
          <Link to="" onClick={handleGoBack} className="icon-retour-ajcmu">
            <i className="bi bi-arrow-left-short" />
          </Link>
        </div>

        {/* Title */}
        <div className="marque-ajcmu">
          <h4>Ajouter un nouveau commercial</h4>
        </div>

        {/* Form card */}
        <div className="form-card-ajcmu">
          <form onSubmit={handleSubmit} method="post">
            {MessageError !== "" && (
              <div className="alert-danger-ajcmu">
                <i className="bi bi-exclamation-circle" /> {MessageError}
              </div>
            )}

            <div className="form-row-ajcmu">
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Nom</label>
                <input
                  type="text"
                  className="form-control-ajcmu"
                  onChange={(e) => setNom(e.target.value)}
                  placeholder="Dupont"
                />
              </div>
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Prénom</label>
                <input
                  type="text"
                  className="form-control-ajcmu"
                  onChange={(e) => setPrénom(e.target.value)}
                  placeholder="Jean"
                />
              </div>
            </div>

            <div className="form-row-ajcmu">
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Numéro de téléphone</label>
                <input
                  type="number"
                  className="form-control-ajcmu"
                  onChange={(e) => setTélephone(e.target.value)}
                  placeholder="06 00 00 00 00"
                />
              </div>
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Ville</label>
                <input
                  type="text"
                  className="form-control-ajcmu"
                  onChange={(e) => setVille(e.target.value)}
                  placeholder="Casablanca"
                />
              </div>
            </div>

            <div className="form-row-ajcmu">
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Remise (%)</label>
                <input
                  type="number"
                  className="form-control-ajcmu"
                  onChange={(e) => setRemiseGlobale(e.target.value)}
                  placeholder="0"
                />
              </div>
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Solde (MAD)</label>
                <input
                  type="number"
                  className="form-control-ajcmu"
                  onChange={(e) => setCredit && setCredit(e.target.value)}
                  placeholder="0"
                />
              </div>
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">CIN</label>
                <input
                  type="text"
                  className="form-control-ajcmu"
                  onChange={(e) => setCin && setCin(e.target.value)}
                  placeholder="EX123456"
                  maxLength={8}
                />
              </div>
            </div>

            <div className="form-row-ajcmu">
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Email</label>
                <input
                  type="email"
                  className="form-control-ajcmu"
                  onChange={(e) => setEmail && setEmail(e.target.value)}
                  placeholder="email@exemple.com"
                />
              </div>
              <div className="form-group-ajcmu">
                <label className="form-label-ajcmu">Mot de passe</label>
                <input
                  type="password"
                  className="form-control-ajcmu"
                  onChange={(e) => setPassword && setPassword(e.target.value)}
                  placeholder="••••••••"
                />
              </div>
            </div>

            <div className="btn-submit-wrap-ajcmu">
              <button className="btn-submit-ajcmu" type="submit">
                <i className="bi bi-person-plus" /> Ajouter un commercial
              </button>
            </div>
          </form>
        </div>
      </div>

      {showSuccessPopup && (
        <div className="popup-overlay-ajcmu">
          <div className="popup-box-ajcmu">
            <i className="bi bi-check-circle-fill popup-icon-ajcmu" />
            <h5>Félicitations ! Commercial ajouté</h5>
            <p>Identifiants envoyés sous 24h par email</p>
          </div>
        </div>
      )}

      {showErrorPopup && (
        <div className="popup-overlay-ajcmu">
          <div className="popup-box-ajcmu" style={{ color: 'red' }}>
            <i className="bi bi-exclamation-circle-fill popup-icon-ajcmu" style={{ color: 'red' }} />
            <h5 style={{ color: 'red' }}>Erreur !</h5>
            <p>{MessageError}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default AjouterCommecial;